import React from "react";

export function TBodyCell({
  children,
  isLastCell,
}: {
  children: React.ReactNode;
  isLastCell?: boolean;
}) {
  return (
    <div
      className={`p-4 py-0 pl-4 text-left text-sm text-foreground ${
        isLastCell ? "flex justify-end" : ""
      }`}
      role="none"
      aria-label={typeof children === "string" ? children : undefined}
    >
      {children}
    </div>
  );
}
